module.exports = __webpack_public_path__ + "img/emoji_zhayan.bfb3811f.png";